export interface IAuthConfig
{
	/** The application client id. */
	client_id: string,
	/** The domain of our Auth0 server. */
	domain: string,
	/** The uri we direct to after the user has Logged in at the universal login. */
	redirect_uri: string,
	/** The uri we direct to after the user has logged out. */
	logout_redirect_uri: string,
	/** What scopes the user is requesting. E.g. 'read:all' */
	scope?: string,
	/** The API Id of the Auth0 application we're trying to access */
	audience: string,
}

let _authConfig: IAuthConfig | undefined = undefined;

export function setAuthConfig(config: IAuthConfig) { _authConfig = config; }
export function getAuthConfig() { return _authConfig as IAuthConfig; }